import { render } from "./ks-bankpol-view.vue?vue&type=template&id=095f7831"
import script from "./ks-bankpol-view.vue?vue&type=script&setup=true&lang=js"
export * from "./ks-bankpol-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/nsi/ks-bankpol-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "095f7831"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('095f7831', __exports__)) {
    api.reload('095f7831', __exports__)
  }
  
  module.hot.accept("./ks-bankpol-view.vue?vue&type=template&id=095f7831", () => {
    api.rerender('095f7831', render)
  })

}


export default __exports__